var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "myCenter"
  }, [_c('Header'), _c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "material-list"
  }, _vm._l(_vm.materialList, function (item, index) {
    return _c('li', {
      key: index,
      class: {
        'active': _vm.currentIndex === index
      },
      on: {
        "click": function click($event) {
          return _vm.selectMaterial(index, item.id, item.classifyName, item.classifyId);
        }
      }
    }, [_c('img', {
      attrs: {
        "src": item.mallTypeImage.sourceUrl
      }
    }), _c('div', {
      staticClass: "pag"
    }, [_c('span', [_vm._v(_vm._s(item.classifyName))]), _c('em', {
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.goDetails(item.id);
        }
      }
    }, [_vm._v(" 详情 "), _c('i', {
      staticClass: "iconfont icongengduoxiangqing-copy"
    })])])]);
  }), 0)]), _c('div', {
    staticClass: "next"
  }, [_c('span', {
    on: {
      "click": _vm.next
    }
  }, [_vm._v("下一步(1/3)")])]), _c('BackTop', {
    attrs: {
      "hasShopping": false
    }
  }), _c('Footer')], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };